import {
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH,
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS,
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE,
  CREATE_CONTACT_PERSON,
  CREATE_CONTACT_PERSON_SUCCESS,
  CREATE_CONTACT_PERSON_FAILURE,
  GET_SINGLE_PERSON_CONTACT_DETAILS,
  GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS,
  GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE,
  DELETE_CONTACT_PERSON,
  DELETE_CONTACT_PERSON_SUCCESS,
  DELETE_CONTACT_PERSON_FAILURE,
  UPDATE_CONTACT_PERSON,
  UPDATE_CONTACT_PERSON_SUCCESS,
  UPDATE_CONTACT_PERSON_FAILURE,
  DELETE_CONTACT_PERSON_RELATIONSHIP,
  DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS,
  DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE,
  CONTACT_PERSON_DATA,
  CONTACT_PERSON_DATA_SUCCESS,
  CONTACT_PERSON_DATA_FAILURE,
  CONTACT_PERSON_LIST,
  CONTACT_PERSON_LIST_SUCCESS,
  CONTACT_PERSON_LIST_FAILURE,
  SEARCH_PERSON_WITH_CUSTOMER_ID,
  SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS,
  SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE,
} from "./actionType";

// Reducer for Contact Person Search with Company's id List returned

const initialState = {
  loading: false,
  createContactPersonLoading: false,
  contactPersonSingleCompanySearchList: [],
  error: "",
  createContactPersonSuccess: [],
  getSinglePersonContactDetails: [],
  singlePersonContactDetailsLoading: false,
  deleteContactPersonSuccess: [],
  deleteContactPersonLoading: false,
  updateContactPersonSuccess: [],
  updateContactPersonLoading: false,
  deleteContactPersonRelationshipSuccess: [],
  deleteContactPersonRelationshipLoading: false,
  contactPersonToEmailInboundSearchList: [],
  contactPersonToEmailInboundSearchListLoading: false,
  contactPersonToEmailInboundData: [],
  contactPersonToEmailInboundDataLoading: false,
  contactPersonData: [],
  contactPersonDataLoading: false,
  contactPersonList: [],
  contactPersonListLoading: false,
  searchPersonWithCustomerId: [],
  searchPersonWithCustomerIdLoading: false,
  customerToContactPersonRelationshipSearch: [],
  customerToContactPersonRelationshipSearchLoading: false,
};

const People = (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_PERSON_SINGLE_COMPANY_SEARCH:
      return {
        ...state,
        loading: true,
        contactPersonSingleCompanySearchList: action.data,
      };
    case CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        contactPersonSingleCompanySearchList: action.data,
      };
    case CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CREATE_CONTACT_PERSON:
      return {
        ...state,
        createContactPersonLoading: true,
      };
    case CREATE_CONTACT_PERSON_SUCCESS:
      return {
        ...state,
        createContactPersonLoading: false,
        createContactPersonSuccess: action.data,
      };
    case CREATE_CONTACT_PERSON_FAILURE:
      return {
        ...state,
        createContactPersonLoading: false,
      };
    case GET_SINGLE_PERSON_CONTACT_DETAILS:
      return {
        ...state,
        singlePersonContactDetailsLoading: true,
      };
    case GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        singlePersonContactDetailsLoading: false,
        getSinglePersonContactDetails: action.data,
      };
    case GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE:
      return {
        ...state,
        singlePersonContactDetailsLoading: false,
      };
    case DELETE_CONTACT_PERSON:
      return {
        ...state,
        deleteContactPersonLoading: true,
      };
    case DELETE_CONTACT_PERSON_SUCCESS:
      return {
        ...state,
        deleteContactPersonLoading: false,
        deleteContactPersonSuccess: action.data,
      };
    case DELETE_CONTACT_PERSON_FAILURE:
      return {
        ...state,
        deleteContactPersonLoading: false,
      };
    case UPDATE_CONTACT_PERSON:
      return {
        ...state,
        updateContactPersonLoading: true,
      };
    case UPDATE_CONTACT_PERSON_SUCCESS:
      return {
        ...state,
        updateContactPersonLoading: false,
        updateContactPersonSuccess: action.data,
      };

    case UPDATE_CONTACT_PERSON_FAILURE:
      return {
        ...state,
        updateContactPersonLoading: false,
      };

    case DELETE_CONTACT_PERSON_RELATIONSHIP:
      return {
        ...state,
        deleteContactPersonRelationshipLoading: true,
      };
    case DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS:
      return {
        ...state,
        deleteContactPersonRelationshipLoading: false,
        deleteContactPersonRelationshipSuccess: action.data,
      };
    case DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE:
      return {
        ...state,
        deleteContactPersonRelationshipLoading: false,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH:
      return {
        ...state,
        contactPersonToEmailInboundSearchListLoading: true,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS:
      return {
        ...state,
        contactPersonToEmailInboundSearchListLoading: false,
        contactPersonToEmailInboundSearchList: action.payload,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE:
      return {
        ...state,
        contactPersonToEmailInboundSearchListLoading: false,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_DATA:
      return {
        ...state,
        contactPersonToEmailInboundDataLoading: true,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS:
      return {
        ...state,
        contactPersonToEmailInboundDataLoading: false,
        contactPersonToEmailInboundData: action.payload,
      };
    case CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE:
      return {
        ...state,
        contactPersonToEmailInboundDataLoading: false,
      };
    case CONTACT_PERSON_DATA:
      return {
        ...state,
        contactPersonDataLoading: true,
      };
    case CONTACT_PERSON_DATA_SUCCESS:
      return {
        ...state,
        contactPersonDataLoading: false,
        contactPersonData: action.payload,
      };
    case CONTACT_PERSON_DATA_FAILURE:
      return {
        ...state,
        contactPersonDataLoading: false,
      };
    case CONTACT_PERSON_LIST:
      return {
        ...state,
        contactPersonListLoading: true,
      };
    case CONTACT_PERSON_LIST_SUCCESS:
      return {
        ...state,
        contactPersonListLoading: false,
        contactPersonList: action.payload,
      };
    case CONTACT_PERSON_LIST_FAILURE:
      return {
        ...state,
        contactPersonListLoading: false,
      };
    case SEARCH_PERSON_WITH_CUSTOMER_ID:
      return {
        ...state,
        searchPersonWithCustomerIdLoading: true,
      };
    case SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS:
      return {
        ...state,
        searchPersonWithCustomerIdLoading: false,
        searchPersonWithCustomerId: action.payload,
      };
    case SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE:
      return {
        ...state,
        searchPersonWithCustomerIdLoading: false,
      };
    case CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH:
      return {
        ...state,
        customerToContactPersonRelationshipSearchLoading: true,
      };
    case CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS:
      return {
        ...state,
        customerToContactPersonRelationshipSearchLoading: false,
        customerToContactPersonRelationshipSearch: action.payload,
      };
    case CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE:
      return {
        ...state,
        customerToContactPersonRelationshipSearchLoading: false,
      };

    default:
      return state;
  }
};

export default People;
